/**
 * ew-product.js — Emily Watson Product Page
 * Handles: variant selection, tab switching, product recommendations, wishlist, mobile carousel
 */

(function () {
  'use strict';

  if (!window.ewProductData) return;

  const data = window.ewProductData;
  const variants = data.variants;

  const variantInput = document.getElementById('ew-variant-id-' + data.sectionId);
  const atcBtn = document.getElementById('ew-atc-btn');
  const variantMsgWrap = document.getElementById('ew-variant-message');
  const priceEl = document.getElementById('ew-price');
  const colorValueEl = document.getElementById('ew-color-value');
  const wishlistBtn = document.querySelectorAll('.ew-wishlist-btn');

  const selectedOptions = {};

  function init() {
    initOptionSwatches();
    initTabs();
    initWishlist();
    initCarousel();
    initSizeChart();
    initOrderNow();
    initAddToCart();

    if (data.showRecommendations) initRecommendations();
  }

  // Option swatches
  function initOptionSwatches() {
    const swatches = document.querySelectorAll('.ew-size-swatch, .ew-color-swatch');
    swatches.forEach(function (btn) {
      const optionIndex = parseInt(btn.dataset.optionIndex, 10);
      const value = btn.dataset.value;
      if (btn.classList.contains('ew-size-swatch--selected') ||
          btn.classList.contains('ew-color-swatch--selected')) {
        selectedOptions[optionIndex] = value;
      }
      btn.addEventListener('click', function () {
        selectedOptions[optionIndex] = value;
        const siblings = document.querySelectorAll('[data-option-index="' + optionIndex + '"]');
        siblings.forEach(function (s) {
          s.classList.remove('ew-size-swatch--selected', 'ew-color-swatch--selected');
        });
        if (btn.classList.contains('ew-size-swatch')) {
          btn.classList.add('ew-size-swatch--selected');
        } else {
          btn.classList.add('ew-color-swatch--selected');
          if (colorValueEl) colorValueEl.textContent = value;
        }
        updateVariant();
      });
    });
        updateSwatchAvailability();

  }

function updateVariant() {
    const optionValues = Object.keys(selectedOptions)
      .sort(function (a, b) { return a - b; })
      .map(function (k) { return selectedOptions[k]; });

    const matched = variants.find(function (v) {
      return v.options.every(function (opt, i) {
        return optionValues[i] === undefined || opt === optionValues[i];
      });
    });

    if (!matched) return;

    if (variantInput) variantInput.value = matched.id;

    const url = new URL(window.location.href);
    url.searchParams.set('variant', matched.id);
    window.history.replaceState({}, '', url.toString());

    updatePrice(matched);
    updateButton(matched);
    updateStatusMessage(matched);
    updateWishlistState();
    updateSwatchAvailability();
  }
function updateSwatchAvailability() {
    var swatches = document.querySelectorAll('.ew-size-swatch, .ew-color-swatch');

    swatches.forEach(function(swatch) {
      var optionIndex = parseInt(swatch.dataset.optionIndex, 10);
      var value = swatch.dataset.value;

      // Build a test option set using current selections but swap this swatch's value
      var testOptions = Object.assign({}, selectedOptions);
      testOptions[optionIndex] = value;

      var testValues = Object.keys(testOptions)
        .sort(function(a, b) { return a - b; })
        .map(function(k) { return testOptions[k]; });

      // Find if any variant with this combination is available
      var isAvailable = variants.some(function(v) {
        return v.options.every(function(opt, i) {
          return testValues[i] === undefined || opt === testValues[i];
        }) && v.available;
      });

      if (swatch.classList.contains('ew-size-swatch')) {
        swatch.classList.toggle('ew-size-swatch--sold-out', !isAvailable);
      }
    });
  }
  function updatePrice(variant) {
    if (!priceEl) return;
    let html = '';
    if (variant.compareAtPrice && variant.compareAtPrice > variant.price) {
      html += '<s class="ew-price--compare">' + formatMoney(variant.compareAtPrice) + '</s> ';
    }
    html += formatMoney(variant.price);
    priceEl.innerHTML = html;
  }

  function updateButton(variant) {
    if (!atcBtn) return;
    var orderNowBtn = document.getElementById('ew-order-now-btn');
    if (variant.available) {
      atcBtn.disabled = false;
      atcBtn.classList.remove('ew-btn--sold-out');
      atcBtn.textContent = 'ADD TO CART';
      if (orderNowBtn) {
        orderNowBtn.disabled = false;
        orderNowBtn.classList.remove('ew-btn--sold-out');
      }
    } else {
      atcBtn.disabled = true;
      atcBtn.classList.add('ew-btn--sold-out');
      atcBtn.textContent = 'SOLD OUT';
      if (orderNowBtn) {
        orderNowBtn.disabled = true;
        orderNowBtn.classList.add('ew-btn--sold-out');
      }
    }
  }

function initOrderNow() {
    var orderNowBtn = document.getElementById('ew-order-now-btn');
    if (!orderNowBtn) return;

    orderNowBtn.addEventListener('click', function() {
      var variantId = variantInput ? variantInput.value : null;
      if (!variantId) return;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function() {
        window.location.href = '/checkout';
      })
      .catch(function(err) {
        console.error('Error adding to cart:', err);
      });
    });
  }


  function updateStatusMessage(variant) {
    var stockEl = document.getElementById('ew-stock-inline');
    var shipEl = document.getElementById('ew-shipping-message');

    const avType = (variant.availabilityType || '').toLowerCase();
    const customMsg = variant.shippingMessage || '';
    const qty = variant.inventoryQuantity;
    const policy = variant.inventoryPolicy;

    var statusHtml = '';
    var statusClass = '';
    var shipMsg = customMsg || 'Ships within 1-2 business days.';

    if (avType === 'made_to_order') {
      statusHtml = '';
      statusClass = '';
      shipMsg = customMsg || 'This Variant is Made to order. Ships within 10 business days';
    } else if (avType === 'pre_order') {
      statusHtml = '';
      statusClass = '';
      shipMsg = customMsg || 'This Variant is Pre order. Ready to ship 1 July';
    } else if (qty <= 0 && policy !== 'continue') {
      statusHtml = 'Sold out';
      statusClass = 'ew-status--sold-out';
      shipMsg = '';
    } else if (qty <= 0 && policy === 'continue') {
      statusHtml = '';
      statusClass = '';
    } else if (qty <= 5) {
      statusHtml = 'Only ' + qty + ' left in stock!';
      statusClass = 'ew-status--low';
    } else {
      statusHtml = 'In stock!';
      statusClass = 'ew-status--in-stock';
    }

    if (stockEl) {
      stockEl.innerHTML = '<span class="ew-variant-status ' + statusClass + '">' + statusHtml + '</span>';
    }
    if (shipEl) {
      shipEl.textContent = shipMsg;
    }
  }

  // Wishlist
  var WISHLIST_KEY = 'ew_wishlist';

  function getWishlist() {
    try {
      var raw = JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
      return raw.map(function(item) {
        if (typeof item === 'object') return item;
        return { id: item, handle: null };
      });
    } catch (e) { return []; }
  }

  function saveWishlist(list) {
    try {
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function isWishlisted() {
    var list = getWishlist();
    return list.some(function(item) { return item.id === data.productId; });
  }

  function toggleWishlist() {
    var list = getWishlist();
    var idx = list.findIndex(function(item) { return item.id === data.productId; });
    if (idx === -1) {
      list.push({ id: data.productId, handle: data.productHandle });
    } else {
      list.splice(idx, 1);
    }
    saveWishlist(list);
    updateWishlistState();
    updateHeaderWishlist();
  }

  function updateWishlistState() {
    if (!wishlistBtn.length) return;
    var wishlisted = isWishlisted();
    wishlistBtn.forEach(function (btn) {
      var svg = btn.querySelector('svg path');
      if (wishlisted) {
        btn.classList.add('ew-wishlist-btn--active');
        btn.setAttribute('aria-label', 'Remove from wishlist');
        if (svg) svg.setAttribute('fill', 'currentColor');
      } else {
        btn.classList.remove('ew-wishlist-btn--active');
        btn.setAttribute('aria-label', 'Add to wishlist');
        if (svg) svg.setAttribute('fill', 'none');
      }
    });
  }

  function initWishlist() {
    if (!wishlistBtn.length) return;
    updateWishlistState();
    wishlistBtn.forEach(function (btn) {
      btn.addEventListener('click', toggleWishlist);
    });
  }

  function updateHeaderWishlist() {
    var countEl = document.getElementById('ew-header-wishlist-number');
    var bubbleEl = document.getElementById('ew-header-wishlist-count');
    var btnEl = document.getElementById('ew-header-wishlist-btn');
    if (!countEl || !bubbleEl) return;
    try {
      var list = getWishlist();
      if (list.length > 0) {
        countEl.textContent = list.length;
        bubbleEl.style.display = 'flex';
        if (btnEl) btnEl.classList.add('ew-header-wishlist--active');
      } else {
        bubbleEl.style.display = 'none';
        if (btnEl) btnEl.classList.remove('ew-header-wishlist--active');
      }
    } catch(e) {}
  }

  updateHeaderWishlist();

  // Tabs — single handler for both desktop overlay and mobile accordion
  function initTabs() {
    var tabs = document.querySelectorAll('.ew-tabs__tab');
    var overlay = document.getElementById('ew-tab-overlay');
    var closeBtn = document.getElementById('ew-tab-overlay-close');
    var overlayPanels = document.querySelectorAll('.ew-tab-overlay__panel');

    function isMobile() { return window.innerWidth <= 749; }

    function openDesktopTab(target) {
      overlayPanels.forEach(function(p) { p.classList.remove('ew-tab-overlay__panel--active'); });
      var panel = document.getElementById('ew-tab-overlay-' + target);
      if (panel) panel.classList.add('ew-tab-overlay__panel--active');
      if (overlay) {
        overlay.classList.add('ew-tab-overlay--open');
        overlay.setAttribute('aria-hidden', 'false');
      }
    }

    function closeDesktopTab() {
      if (overlay) {
        overlay.classList.remove('ew-tab-overlay--open');
        overlay.setAttribute('aria-hidden', 'true');
      }
      overlayPanels.forEach(function(p) { p.classList.remove('ew-tab-overlay__panel--active'); });
    }

    function openMobileTab(target) {
      var panel = document.getElementById('ew-mobile-panel-' + target);
      var isActive = panel && panel.classList.contains('ew-mobile-accordion__panel--active');

      document.querySelectorAll('.ew-mobile-accordion__panel').forEach(function(p) {
        p.classList.remove('ew-mobile-accordion__panel--active');
      });

      if (!isActive && panel) {
        panel.classList.add('ew-mobile-accordion__panel--active');
      } else {
        tabs.forEach(function(t) { t.classList.remove('ew-tabs__tab--active'); });
      }
    }

    // Single click handler per tab
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var target = tab.dataset.tab;
        var isActive = tab.classList.contains('ew-tabs__tab--active');

        tabs.forEach(function(t) { t.classList.remove('ew-tabs__tab--active'); });

        if (isActive) {
          closeDesktopTab();
          return;
        }

        tab.classList.add('ew-tabs__tab--active');

        if (isMobile()) {
          openMobileTab(target);
        } else {
          openDesktopTab(target);
        }
      });
    });

    // Desktop overlay close button
    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        closeDesktopTab();
        tabs.forEach(function(t) { t.classList.remove('ew-tabs__tab--active'); });
      });
    }

    // Mobile accordion close buttons
    document.querySelectorAll('.ew-mobile-accordion__close').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var target = btn.dataset.close;
        var panel = document.getElementById('ew-mobile-panel-' + target);
        if (panel) panel.classList.remove('ew-mobile-accordion__panel--active');
        tabs.forEach(function(t) {
          if (t.dataset.tab === target) t.classList.remove('ew-tabs__tab--active');
        });
      });
    });
  }

function initSizeChart() {
    var trigger = document.getElementById('ew-size-chart-trigger');
    var modal = document.getElementById('ew-size-chart-modal');
    var closeBtn = document.getElementById('ew-size-chart-close');
    var overlay = document.getElementById('ew-size-chart-overlay');

    if (!trigger || !modal) return;

    trigger.addEventListener('click', function() {
      modal.classList.add('ew-size-chart-modal--open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    });

    function closeModal() {
      modal.classList.remove('ew-size-chart-modal--open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', function(e) {
      if (e.target === modal) closeModal();
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeModal();
    });
  }



  // Mobile carousel
function initCarousel() {
    var gallery = document.getElementById('ew-media-gallery');
    var items = document.querySelectorAll('.ew-media-item');

    if (!gallery || items.length === 0) return;

    var prevBtn = document.getElementById('ew-carousel-prev');
    var nextBtn = document.getElementById('ew-carousel-next');
    var dots = document.querySelectorAll('.ew-carousel-dot');

    var currentIndex = 0;
    var totalItems = items.length;

    function goTo(index) {
      if (index < 0) index = totalItems - 1;
      if (index >= totalItems) index = 0;
      currentIndex = index;

      if (window.innerWidth <= 749) {
        items.forEach(function(item, i) {
          item.classList.toggle('ew-media-item--active', i === currentIndex);
        });
        dots.forEach(function(dot, i) {
          dot.classList.toggle('ew-carousel-dot--active', i === currentIndex);
        });
      }
    }

    if (prevBtn) prevBtn.addEventListener('click', function() { goTo(currentIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { goTo(currentIndex + 1); });

    dots.forEach(function(dot, i) {
      dot.addEventListener('click', function() { goTo(i); });
    });

    var touchStartX = 0;
    var touchEndX = 0;

    gallery.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    gallery.addEventListener('touchend', function(e) {
      touchEndX = e.changedTouches[0].screenX;
      var diff = touchStartX - touchEndX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          goTo(currentIndex + 1);
        } else {
          goTo(currentIndex - 1);
        }
      }
    }, { passive: true });

    goTo(0);

    window.addEventListener('resize', function() {
      if (window.innerWidth > 749) {
        items.forEach(function(item) {
          item.classList.remove('ew-media-item--active');
        });
      } else {
        goTo(currentIndex);
      }
    });
  }

  // Recommendations
  function initRecommendations() {
    const grid = document.getElementById('ew-recommendations-grid');
    if (!grid) return;
    const url = '/recommendations/products.json?product_id=' + data.productId + '&limit=4&intent=related';
    fetch(url)
      .then(function (res) { return res.json(); })
      .then(function (json) {
        if (!json.products || json.products.length === 0) {
          document.getElementById('ew-recommendations').style.display = 'none';
          return;
        }
        renderRecommendations(json.products, grid);
      })
      .catch(function () {
        var section = document.getElementById('ew-recommendations');
        if (section) section.style.display = 'none';
      });
  }

  function renderRecommendations(products, grid) {
    const html = products.map(function (product) {
      const image = product.featured_image
        ? '<img src="' + product.featured_image + '&width=400" alt="' + escapeHtml(product.title) + '" loading="lazy">'
        : '';
      const price = formatMoney(product.price_min);
      return '<a href="' + product.url + '" class="ew-rec-card">' +
        '<div class="ew-rec-card__image">' + image + '</div>' +
        '<p class="ew-rec-card__title">' + escapeHtml(product.title) + '</p>' +
        '<p class="ew-rec-card__price">' + price + '</p>' +
        '</a>';
    }).join('');
    grid.innerHTML = html;
  }

  // Helpers
  function formatMoney(cents) {
    const symbol = data.currencySymbol || '$';
    return symbol + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function escapeHtml(str) {
    const div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }
function initAddToCart() {
    var form = document.getElementById(data.formId);
    if (!form) return;

    var popup = document.getElementById('ew-cart-popup');
    var closeBtn = document.getElementById('ew-cart-popup-close');
    var continueBtn = document.getElementById('ew-cart-popup-continue');
    var overlay = document.getElementById('ew-cart-popup-overlay');

    function closePopup() {
      popup.classList.remove('ew-cart-popup--open');
      popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    if (closeBtn) closeBtn.addEventListener('click', closePopup);
    if (continueBtn) continueBtn.addEventListener('click', closePopup);
    popup.addEventListener('click', function(e) {
      if (e.target === popup) closePopup();
    });

    form.addEventListener('submit', function(e) {
      e.preventDefault();

      var variantId = variantInput ? variantInput.value : null;
      if (!variantId) return;

      atcBtn.textContent = 'ADDING...';
      atcBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function(res) { return res.json(); })
      .then(function(item) {
        // Update popup content
        var titleEl = document.getElementById('ew-cart-popup-product-title');
        var variantEl = document.getElementById('ew-cart-popup-product-variant');
        var priceEl = document.getElementById('ew-cart-popup-product-price');
        var imageEl = document.getElementById('ew-cart-popup-image');

        if (titleEl) titleEl.textContent = item.product_title;
        if (variantEl) variantEl.textContent = item.variant_title !== 'Default Title' ? item.variant_title : '';
        if (priceEl) priceEl.textContent = formatMoney(item.price);
        if (imageEl && item.image) {
          imageEl.innerHTML = '<img src="' + item.image + '" alt="' + item.product_title + '">';
        }

        // Show popup
        popup.classList.add('ew-cart-popup--open');
        popup.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';

        // Reset button
        atcBtn.textContent = 'ADD TO CART';
        atcBtn.disabled = false;

        // Update cart count in header if Dawn's cart bubble exists
        fetch('/cart.js')
          .then(function(res) { return res.json(); })
          .then(function(cart) {
            var cartBubble = document.querySelector('.cart-count-bubble span[aria-hidden]');
            if (cartBubble) cartBubble.textContent = cart.item_count;
          });
      })
      .catch(function(err) {
        console.error('Error adding to cart:', err);
        atcBtn.textContent = 'ADD TO CART';
        atcBtn.disabled = false;
      });
    });
  }
  // Boot
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();